import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { formatQuantityValue } from "../../utils/formatQuantityValue";
import type { QuantityDeltaProps } from "./types";

export const QuantityDelta = ({ delta, kind }: QuantityDeltaProps) => {
  const { i18n } = useTranslation();

  if (delta === 0) {
    return <span className="text-sm text-gray-400">—</span>;
  }

  const formattedDelta = formatQuantityValue({
    value: Math.abs(delta),
    language: i18n.language,
    kind,
  });

  return (
    <span
      className={clsx(
        "whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium tabular-nums sm:text-sm",
        delta > 0 ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700",
      )}
    >
      {delta > 0 ? "+" : "−"}
      {formattedDelta}
    </span>
  );
};
